export default __webpack_public_path__ + "static/media/NoOpenings.097a2b6d.jpg";